import React from 'react';
import {useAppDispatch, useAppSelector} from '../../store/hooks';
import {Page} from '../../types/enums/page.enum';
import {set as setPage} from '../../store/features/pages/pageSlice';
import {CTA} from '@volkswagen-onehub/components-core';
import {set as setResult} from '../../store/features/results/resultSlice';
import {
  set as setRanking,
} from '../../store/features/rankingSlice';
import {Stats} from '../../types/stats';
import useTrans from '../../hooks/use-trans';
import { ModelData } from '../../types/models';
import { CTAWrapper } from '../../styles/global.style';
import { Language } from '../../types/locale';
import { useFeatureServices } from '../../use-feature-services';
import questions from '../../data/questions';

interface PollFinishInterface {
  disabled: boolean;
}

const PollFinish: React.FC<PollFinishInterface> = ({disabled}) => {
  const { tracking } = useFeatureServices();

  const trans = useTrans();
  const enTrans = useTrans("en" as Language);

  const dispatch = useAppDispatch();

  const answers = useAppSelector((state) => state.answers);

  const onFinish = () => {
    const stats: Stats = {};

    Object.values(answers).forEach((answer) => {
      answer?.models.forEach((m : ModelData) => {
        if (!stats[m.model]) {
          stats[m.model] = {count: 0, minPriority: m.priority, model: m, result:  trans.results[m.model]};
        }

        stats[m.model].count += 1;
        stats[m.model].minPriority = Math.min(
          stats[m.model].minPriority,
          m.priority,
        );
      });
    });

    const ranked = Object.entries(stats).sort(([, a], [, b]) => {
      if (b.count !== a.count) return b.count - a.count;
      return a.minPriority - b.minPriority;
    });

    dispatch(setRanking(ranked));

    const [winnerKey, winnerValue] = ranked[0] ?? [];

    if (winnerKey && winnerValue) {
      dispatch(setResult(winnerValue));
      dispatch(setPage(Page.FORM));
    }

    const totalSteps = Object.keys(questions).length;

    tracking.track('VWBasic_Button_Click', {
      eventInfo: {
        contentId: 'See Results',
        brand: "passenger"
      },
      process: {
        Name: 'SUVW Questionnaire and Lead Capture Form',
        StepName: 'Questionnaire - Complete',
        StepNumber: `${totalSteps}`,
      },
      link: {
        url: window.location.href,
        name: enTrans.pages.poll.seeResult
      }
    });
  };

  return (
    <CTAWrapper>
      <CTA
        tag="button"
        emphasis="primary"
        onClick={onFinish}
        aria-label={trans.pages.poll.seeResult}
        type="button"
        disabled={disabled}
      >{trans.pages.poll.seeResult}</CTA>
    </CTAWrapper>
  );
};

export default PollFinish;
